CustomBackgroundOptionsView = require 'app/scripts/views/board-menu/custom-background-options-view'
PopOver = require 'app/scripts/views/lib/pop-over'
Util = require 'app/scripts/lib/util'
{ featureFlagClient } = require '@trello/feature-flag-client'
{ Analytics } = require '@trello/atlassian-analytics'
templates = require 'app/scripts/views/internal/templates'
_ = require 'underscore'
View = require 'app/scripts/views/internal/view'
{ track } = require '@trello/analytics'


module.exports = class SelectCustomBackgroundView extends View
  initialize: ->
    @listenTo @model, 'change:id', @render
    @listenTo @model, 'change:error', @render

    @sendGASEvent = featureFlagClient.get('dataeng.gasv3-event-tracking', false)

  className: 'board-background-select js-select-background'

  events:
    'click .js-options': 'openOptions'
    'click': 'selectBackground'

  render: ->
    data = @model.toJSON()
    data.pending = !@getId()? && !data.error?

    if !data.color?
      data.backgroundImageThumbnail =
        Util.previewBetween(@model.get('scaled'), 90, 60, 600, 400)?.url ?
        @model.get('fullSizeUrl')

    @$el.html(
      templates.fill(
        'board_background_selection',
        data
      )
    )

    @$el.toggleClass('is-still-uploading-background', data.pending)

    @

  openOptions: (e) ->
    Util.stop(e)
    if @sendGASEvent
      Analytics.sendUIEvent
        action: 'clicked'
        actionSubject: 'link'
        actionSubjectId: 'backgroundOptionsLink'
        source: 'boardMenuDrawerBackgroundScreen'
    PopOver.toggle
      elem: @$('.js-options')
      view: new CustomBackgroundOptionsView({ @model, @modelCache })

  getId: ->
    @model.id

  selectBackground: (e) ->
    Util.stop(e)
    return if !@getId()?

    board = @options.board
    # Update the local data so we don't have to wait for the server to respond
    _.extend(board.attributes.prefs, {
      backgroundColor: @model.get('color')
      backgroundImage: @model.get('fullSizeUrl')
      backgroundImageScaled: @model.get('scaled')
      backgroundTile: @model.get('tile') ? false
      backgroundBrightness: @model.get('brightness') ? 'unknown'
    })

    board.setPref "background", @getId()

    track("Board Menu", "Change Background", @getId())
    if @sendGASEvent
      Analytics.sendTrackEvent
        action: 'set'
        actionSubject: 'boardBackground'
        actionSubjectId: 'customBoardBackground'
        source: 'boardMenuDrawerBackgroundScreen'
        containers:
          board:
            id: board.id
        attributes:
          backgroundId: @getId()
    return
